export const BACKEND_URL = import.meta.env.VITE_BACKEND_URL || ''
export const API_URL = import.meta.env.VITE_API_URL || ''
